import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var HomeIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    d: "M45.8 27.89L25.42 7.51001C25.3048 7.39391 25.1677 7.30177 25.0166 7.23889C24.8656 7.17601 24.7036 7.14355 24.54 7.14355C24.3764 7.14355 24.2145 7.17601 24.0634 7.23889C23.9124 7.30177 23.7753 7.39391 23.66 7.51001L3.1 28.0699C2.88643 28.3075 2.77192 28.6178 2.77994 28.9371C2.78796 29.2565 2.91792 29.5606 3.14316 29.7871C3.36839 30.0136 3.67177 30.1453 3.99106 30.1552C4.31034 30.165 4.62127 30.0522 4.86001 29.84L7.25003 27.45V41.51C7.25003 41.8415 7.3817 42.1595 7.61612 42.3939C7.85054 42.6283 8.16851 42.76 8.50003 42.76H40.24C40.5715 42.76 40.8895 42.6283 41.1239 42.3939C41.3583 42.1595 41.49 41.8415 41.49 41.51V27.11L44.0301 29.66C44.2671 29.8903 44.5845 30.0192 44.915 30.0192C45.2455 30.0192 45.563 29.8903 45.8 29.66C45.9164 29.5439 46.0088 29.4059 46.0718 29.254C46.1348 29.1022 46.1673 28.9394 46.1673 28.775C46.1673 28.6106 46.1348 28.4478 46.0718 28.2959C46.0088 28.144 45.9164 28.0061 45.8 27.89ZM39 25V40.29H9.75003V25L24.54 10.21L39.05 24.72C39.0201 24.8104 39.0033 24.9048 39 25Z"
  }));
});
HomeIcon.displayName = 'HomeIcon';
HomeIcon.defaultProps = {
  'aria-label': 'Home'
};
export default HomeIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/HomeIcon/index.js
// module id = 1866
// module chunks = 12